import React, { useContext } from 'react';
import { AppContext } from '../../../base/AppContext';
import StreamBuilder from '../common/StreamBuilder';

/**
 * GlobalDialogs - Component quản lý các dialogs global như Alert, Confirm
 * Tương tự module-ui ISmartWrapper
 */
const GlobalDialogs: React.FC = () => {
    const context = useContext(AppContext);
    const blocAppWrapper = context?.app;

    if (!blocAppWrapper) {
        return null;
    }

    const onHideDialog = (type: number) => {
        switch (type) {
            case 0: // Alert
                blocAppWrapper.getStream('dialogAlert').next({ isShow: false });
                break;
            case 1: // Confirm
                blocAppWrapper.getStream('dialogConfirm').next({ isShow: false });
                break;
            case 2: // Info
                blocAppWrapper.getStream('dialogInfo').next({ isShow: false });
                break;
            default:
                blocAppWrapper.getStream('dialogAlert').next({ isShow: false });
                break;
        }
    };

    return (
        <>
            {/* Alert Dialog */}
            <StreamBuilder
                initialData={null}
                stream={blocAppWrapper.getStream('dialogAlert')}
                builder={(snapshot) => {
                    const info = snapshot.data;
                    if (!info?.isShow) return null;

                    return (
                        <div className="dialog-overlay" onClick={() => info.dismiss && onHideDialog(0)}>
                            <div className="dialog-content" onClick={(e) => e.stopPropagation()}>
                                <div className="dialog-header">
                                    <h3>{info.title || 'Thông báo'}</h3>
                                    <button 
                                        className="dialog-close"
                                        onClick={() => onHideDialog(0)}
                                    >
                                        ×
                                    </button>
                                </div>
                                <div className="dialog-body">
                                    <p>{info.message}</p>
                                </div>
                                <div className="dialog-footer">
                                    <button 
                                        className="btn btn-primary"
                                        onClick={() => {
                                            info.onCallBack?.();
                                            onHideDialog(0);
                                        }}
                                    >
                                        {info.label || 'Đóng'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    );
                }}
            />

            {/* Confirm Dialog */}
            <StreamBuilder
                initialData={null}
                stream={blocAppWrapper.getStream('dialogConfirm')}
                builder={(snapshot) => {
                    const info = snapshot.data;
                    if (!info?.isShow) return null;

                    return (
                        <div className="dialog-overlay" onClick={() => info.dismiss && onHideDialog(1)}>
                            <div className="dialog-content" onClick={(e) => e.stopPropagation()}>
                                <div className="dialog-header">
                                    <h3>{info.title || 'Xác nhận'}</h3>
                                    <button 
                                        className="dialog-close"
                                        onClick={() => onHideDialog(1)}
                                    >
                                        ×
                                    </button>
                                </div>
                                <div className="dialog-body">
                                    <p>{info.message}</p>
                                </div>
                                <div className="dialog-footer">
                                    <button 
                                        className="btn btn-secondary"
                                        onClick={() => onHideDialog(1)}
                                    >
                                        {info.labelLeft || 'Hủy'}
                                    </button>
                                    <button 
                                        className="btn btn-primary"
                                        onClick={() => {
                                            info.onCallBack?.(true);
                                            onHideDialog(1);
                                        }}
                                    >
                                        {info.labelRight || 'Xác nhận'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    );
                }}
            />
        </>
    );
};

export default GlobalDialogs;
